export default "__VITE_ASSET__gBTekIA___"